const LEAVE_TYPE_ACTIONS = {
  //get leave type
  GET_LEAVE_TYPE: "GET_LEAVE_TYPE",
  GET_LEAVE_TYPE_SUCCESS: "GET_LEAVE_TYPE_SUCCESS",
  GET_LEAVE_TYPE_FAIL: "GET_LEAVE_TYPE_FAIL",
  //get leave type workflow
  GET_LEAVE_TYPE_WORKFLOW: "GET_LEAVE_TYPE_WORKFLOW",
  GET_LEAVE_TYPE_WORKFLOW_SUCCESS: "GET_LEAVE_TYPE_WORKFLOW_SUCCESS",
  GET_LEAVE_TYPE_WORKFLOW_FAIL: "GET_LEAVE_TYPE_WORKFLOW_FAIL",
};
export default LEAVE_TYPE_ACTIONS;
